export const WORKFLOW = '[Workflow]';

export const SUBMIT_ATTEMPT_SAGA = `${WORKFLOW} SUBMIT_ATTEMPT_SAGA`;
export const REDIRECT_TO_WORKFLOW_SAGA = `${WORKFLOW} REDIRECT_TO_WORKFLOW_SAGA`;
export const SET_TEST_RESULTS_DATA = `${WORKFLOW} SET_TEST_RESULTS_DATA`;
export const SET_WORKFLOW_RESULTS_DATA = `${WORKFLOW} SET_WORKFLOW_RESULTS_DATA`;
export const GET_WORKFLOW_SAGA = `${WORKFLOW} GET_WORKFLOW_SAGA`;
export const SET_WORKFLOW = `${WORKFLOW} SET_WORKFLOW`;
